/**
 * Από την αναγγελία κλήσης (IncomingCallPopup) στην οθόνη delivery ΧΩΡΙΣ φόρτωση σελίδας.
 *
 * ΓΙΑΤΙ: η «Μετάβαση» έκανε window.location.href = '/delivery?phone=…' — πλήρη φόρτωση της
 * εφαρμογής (σβήνει ό,τι είχε ανοιχτό ο ταμίας, ξαναφορτώνει κατάλογο/συνδέσεις) και μετά
 * ξανά αναζήτηση. Η εφαρμογή δεν έχει react-router: το App αλλάζει σελίδα με
 * history.pushState + setCurrentPage (App.handlePageChange). Εδώ το αναδυόμενο αφήνει την
 * «πρόθεση» (τηλέφωνο, και για «Ξανά τα ίδια» την παραγγελία + τη διεύθυνσή της) και
 * στέλνει ένα γεγονός στο window:
 *  - το App ακούει και πάει στη σελίδα delivery (αν δεν είναι ήδη εκεί)·
 *  - το DeliveryWithMap, ανοιχτό ή μόλις ανοίγει, παίρνει την πρόθεση ΜΙΑ φορά
 *    (takePendingDeliveryIntent) και ανοίγει τον πελάτη.
 */

export interface DeliveryCallIntent {
  /** Καθαρό τηλέφωνο: χωρίς +30, χωρίς κενά (ό,τι ψάχνει η αναζήτηση πελάτη). */
  phone: string;
  /** «Ξανά τα ίδια»: η παραγγελία delivery που επαναλαμβάνεται. */
  reorderOrderId?: number | null;
  /** Η διεύθυνση εκείνης της παραγγελίας (customer_addresses.id). */
  addressId?: number | null;
}

export const DELIVERY_INTENT_EVENT = 'xentrix:delivery-intent';

let pending: DeliveryCallIntent | null = null;

/** Το τηλέφωνο όπως το ψάχνει η οθόνη delivery (ίδιος καθαρισμός με την παλιά «Μετάβαση»). */
export const cleanCallerPhone = (phone: string): string =>
  String(phone || '').replace(/^\+30/, '').replace(/^\+/, '').replace(/\s+/g, '');

/** Από το αναδυόμενο: άνοιξε την οθόνη delivery γι' αυτόν τον πελάτη. */
export function openDeliveryForCall(intent: DeliveryCallIntent): void {
  pending = { ...intent, phone: cleanCallerPhone(intent.phone) };
  window.dispatchEvent(new CustomEvent(DELIVERY_INTENT_EVENT, { detail: pending }));
}

/** Από την οθόνη delivery: η εκκρεμής πρόθεση, ΜΙΑ φορά (μετά σβήνεται). */
export function takePendingDeliveryIntent(): DeliveryCallIntent | null {
  const p = pending;
  pending = null;
  return p;
}
